// Converts a pasted YouTube or Vimeo watch/share link into an embeddable iframe URL.
// Falls back to the raw URL if the pattern isn't recognized (e.g. a direct .mp4 link).
export const getEmbedUrl = (url) => {
  if (!url) return ""

  const ytMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([a-zA-Z0-9_-]{6,})/)
  if (ytMatch) return `https://www.youtube.com/embed/${ytMatch[1]}`

  const vimeoMatch = url.match(/vimeo\.com\/(\d+)/)
  if (vimeoMatch) return `https://player.vimeo.com/video/${vimeoMatch[1]}`

  return url
}

export const isEmbeddableVideoUrl = (url) => {
  return /youtube\.com|youtu\.be|vimeo\.com/.test(url || "")
}